import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link, useHistory } from 'react-router-dom';

import RoutePath from 'App/RoutePath';
import { tracking } from 'App/Tracking';
import { Events } from 'App/Tracking/Events';
import { Profession } from 'Book/shared';
import { practitionersQuery_practitioners_edges_node as Practitioner } from 'Services/BeGateway/Practitioner/__generated__/practitionersQuery';
import { parseBeGatewayId } from 'utils/relay';

import { PractitionerAvatar } from './../PractitionerAvatar';
import { LI } from './styles';

export type PractitionerCardProps = {
  practitioner: Practitioner;
  trackingEvent?: Events;
};

export const PractitionerCard = ({
  practitioner,
  trackingEvent = 'talk-browse-practitioner-card-selected',
}: PractitionerCardProps) => {
  const { t } = useTranslation('book', { keyPrefix: 'practitioner' });
  const history = useHistory();

  const { id, firstName, lastName, details } = practitioner || {};
  const profession = details.profileInformation?.profession as Profession;
  const track = () => {
    tracking.track(trackingEvent, {
      practitionerId: id,
    });
  };
  const url = `${RoutePath.BookPractitioners}/${parseBeGatewayId(id)}`;
  const state = { source: 'browse_list' };

  return (
    <LI
      className="practitioner-card"
      onClick={e => {
        e.preventDefault();
        e.stopPropagation();
        history.push(url, state);
        track();
      }}
      data-cy={`${practitioner.firstName}-${practitioner.lastName}-card`}
    >
      <PractitionerAvatar practitioner={practitioner} />
      <Link
        className="no-decoration"
        to={{
          pathname: url,
          state,
        }}
        onClick={track}
      >
        {firstName} {lastName}
      </Link>
      <small>
        {Profession[profession] && profession !== Profession.other
          ? t(`professions.${profession}`)
          : details.type}
      </small>
      {details?.specialities?.areasOfExpertise?.length ? (
        <ul className="expertise" data-testid="expertise-list">
          {details?.specialities?.areasOfExpertise?.slice(0, 5).map(area => {
            if (!area?.translationKey) return <></>;

            return (
              <li key={area?.id}>
                {t(`specialities.${area?.translationKey}`, {
                  defaultValue: '',
                })}
              </li>
            );
          })}
        </ul>
      ) : (
        <></>
      )}
    </LI>
  );
};
